import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Button } from '../components/common/Button';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';
import { api } from '../lib/api';

export function ProfilePage() {
  const { user } = useAuth();
  const { showToast } = useToast();

  const [name, setName] = useState(user?.name || '');
  const [organization, setOrganization] = useState('');
  const [department, setDepartment] = useState('');

  const updateMutation = useMutation({
    mutationFn: api.updateProfile,
    onSuccess: () => {
      showToast('Profile updated successfully', 'success');
    },
    onError: (err) => {
      showToast(err instanceof Error ? err.message : 'Failed to update profile', 'error');
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    updateMutation.mutate({ name, organization, department });
  };

  return (
    <div className="p-6 max-w-2xl">
        <h1 className="text-2xl font-bold text-white mb-6">Profile Settings</h1>

        <div className="bg-wolf-800 rounded-lg border border-wolf-700 p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm text-wolf-300 mb-2">
                Email
              </label>
              <input
                type="email"
                id="email"
                value={user?.email || ''}
                disabled
                className="w-full px-3 py-2 bg-wolf-900 border border-wolf-700 rounded text-wolf-400 cursor-not-allowed"
              />
              <p className="text-xs text-wolf-500 mt-1">Email cannot be changed</p>
            </div>

            <div>
              <label htmlFor="name" className="block text-sm text-wolf-300 mb-2">
                Display Name
              </label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full px-3 py-2 bg-wolf-900 border border-wolf-600 rounded text-white placeholder-wolf-500 focus:outline-none focus:border-action"
                placeholder="Your name"
              />
            </div>

            <div>
              <label htmlFor="organization" className="block text-sm text-wolf-300 mb-2">
                Organization
              </label>
              <input
                type="text"
                id="organization"
                value={organization}
                onChange={(e) => setOrganization(e.target.value)}
                className="w-full px-3 py-2 bg-wolf-900 border border-wolf-600 rounded text-white placeholder-wolf-500 focus:outline-none focus:border-action"
                placeholder="Your organization"
              />
            </div>

            <div>
              <label htmlFor="department" className="block text-sm text-wolf-300 mb-2">
                Department
              </label>
              <input
                type="text"
                id="department"
                value={department}
                onChange={(e) => setDepartment(e.target.value)}
                className="w-full px-3 py-2 bg-wolf-900 border border-wolf-600 rounded text-white placeholder-wolf-500 focus:outline-none focus:border-action"
                placeholder="Your department"
              />
            </div>

            <div className="pt-4">
              <Button type="submit" disabled={updateMutation.isPending}>
                {updateMutation.isPending ? 'Saving...' : 'Save Changes'}
              </Button>
            </div>
          </form>
        </div>
      </div>
  );
}
